export enum TAB_SETTINGS {
  TEMPLATE_ID = 'tabTemplateId',
  ORIGIN_TAB_TEMPLATE_ID = 'originTabTemplateId',
  DOCUMENT_VERSION_STARTER = 'DocumentVersionStarter',
  DEFAULT_NAVIGATION_TAB = 'defaultNavigationTab'
}

// Model
interface Setting {
  name: string;
  value: string;
}

// GENERIC IMPLEMENTATION - GETTER
const getSetting = (settings: Setting[], name: TAB_SETTINGS) =>
  settings?.find((s) => s.name === name);

// GETTERS
export const getSettingValue_TemplateId = (settings: Setting[]) =>
  //Try to find the correctly named prop, if not found try to find the legacy prop
  getSetting(settings, TAB_SETTINGS.ORIGIN_TAB_TEMPLATE_ID)?.value ||
  getSetting(settings, TAB_SETTINGS.TEMPLATE_ID)?.value;

/**
 * If the documentstarter is A:
 *  - first document gets empty version
 *  - After that A...Z
 * If the documentstarter is a number:
 *  - first document gets number.
 *  - following documents get number+1;
 * @param settings
 * @returns
 */
export const getSetting_DocVersionStarter = (settings: Setting[]) =>
  getSetting(settings, TAB_SETTINGS.DOCUMENT_VERSION_STARTER);
